(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.accessibility = {
    attach: function (context, settings) {
      $(document).ready(function () {
        $("a", context).each(function (i, obj) {
          let fileType = /[^.]*$/.exec(obj)[0];
          let allowedTypes = [
            "txt",
            "doc",
            "docx",
            "pdf",
            "xls",
            "xlsx",
            "zip",
            "csv",
            "ppt",
            "pptx",
            "pot",
            "potx",
            "pps",
            "ppsx",
            "sldx",
            "dot",
            "xlt",
            "xltx",
            "css",
            "odt",
            "ott",
            "ods",
            "odp",
          ];

          allowedTypes.some(checkFile);
          function checkFile(file) {
            if (fileType == file) {
              if (!$(obj.parentNode).hasClass("file")) {
                obj.outerHTML =
                  "<span class='file file--mime-application-" +
                  file +
                  "'>" +
                  obj.outerHTML +
                  "</span>";
              }
            }
          }
        });
        // #CQCNINECMS-260
        $('img').each(function () {
          if (!this.alt) {
            this.alt = "";
          }
        });
      });
    },
  };

  // Search form redirect handler.
  Drupal.behaviors.cqc_search = {
    attach: function (context, settings) {
      $(".cqc-search-form").submit(function (e) {
        //prevent the form from actually submitting
        e.preventDefault();
        var searchPage = this.search_page.value;
        var keywords = this.keywords.value;
        var searchPageUrl = searchPage;
        if (keywords.length != 0) {
          searchPageUrl = searchPageUrl + '?fulltext=' + keywords;
        }
        window.location.replace(searchPageUrl);
      });
    },
  };

  // Select all p elements with class "message-box--title" that contain only &nbsp;
  $('.message-box--title').filter(function() {
    return $.trim($(this).html()) === '&nbsp;';
  }).remove();

})(jQuery, Drupal);
